export default theme => {
  return {
    container: {
      height: 500
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/selection/Search/SearchFilter.js